import { Component, createElement } from 'react';
import { connect } from 'react-redux';
import { isMobileOrTablet, WithBreakpointRange } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, withBreakpointRange } from '@optimus-web/core';
import { hideFilter, toggleFilter } from '../../../../../modules/app/actions/filters';

interface Props extends WithBreakpointRange {
    toggleFilter?: $TSFixMeFunction;
    hideFilter?: $TSFixMeFunction;
}

class FilterToggleAction extends Component<Props> {
    componentDidMount() {
        if (isMobileOrTablet(this.props.breakpointRange)) {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            this.props.hideFilter();
        }
    }

    handleClick = () => {
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        this.props.toggleFilter();
    };

    render() {
        // @ts-expect-error $TSFixMeError: Property 'component' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { component } = this.props;

        return createElement(component, {
            title: <LocalizedText textKey={TextKey.Filter} />,
            icon: IconName.Filter,
            onClick: this.handleClick,
        });
    }
}

export default connect(undefined, {
    toggleFilter,
    hideFilter,
})(withBreakpointRange(FilterToggleAction));
